/**
 * 环境变量配置
 * 职责：仅处理环境变量相关配置
 */

export const ENV_CONFIG = {
  // 当前环境
  NODE_ENV: process.env.NODE_ENV,
  IS_DEV: process.env.NODE_ENV === 'development',
  IS_PROD: process.env.NODE_ENV === 'production',
  
  // API配置（默认走同源代理，便于局域网手机访问）
  API_BASE_URL: process.env.REACT_APP_API_BASE || '/api/foodlabel',
  
  // 调试模式
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
  
  // Mock数据
  USE_MOCK: process.env.REACT_APP_USE_MOCK === 'true',
};

export default ENV_CONFIG;
